import React from 'react';
import PropTypes from 'prop-types';
import { getCaseNoteSectionData } from './configStructure'

import './CaseNoteSection.scss'

const CaseNoteSection = (props) => {
    let formattedFields = props.fields;
    const caseNoteSectionData = getCaseNoteSectionData();
        return <div className = "case-note-section-card" >
            <div className = "section-header">
                <span className = "section-header-title" >{ props.sectionName }</span>
                <span className="scope-divider"></span>
                <span className = "section-header-scope" >   { props.sectionScope } </span> 
            </div>

            <div className="section-footer">
            <span className="section-footer-title">{props.eventCode === 'EXTERNAL_CASE_NOTE' ? caseNoteSectionData.notesData[0].name : caseNoteSectionData.notesData[1].name}</span>
            {!formattedFields.CaseNotes && (props.eventCode === 'EXTERNAL_CASE_NOTE' ? props.fields.ExternalNoteText : props.fields.NoteText === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{props.eventCode === 'EXTERNAL_CASE_NOTE' ? props.fields.ExternalNoteText : props.fields.NoteText}</span>)}
            {formattedFields.CaseNotes && formattedFields.CaseNotes === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields.CaseNotes}</span>}
        </div>
        </div>

}

CaseNoteSection.propTypes = {
    fields: PropTypes.object,
    sectionName: PropTypes.string,
    sectionScope: PropTypes.string

};

CaseNoteSection.defaultProps = {};

export default (CaseNoteSection);